import CryptoJS from 'crypto-js';

// Use the secret key from environment variables
const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY || '';
if (!SECRET_KEY) {
  // eslint-disable-next-line no-console
  console.warn('CRYPTO_SECRET_KEY is not set in environment variables! LocalStorage encryption will not work properly.');
}

export class LocalStorageUtils {

    static setStorage(key: string, value: any) {
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
      const ciphertext = CryptoJS.AES.encrypt(stringValue, SECRET_KEY).toString();
      localStorage.setItem(key, ciphertext);
    }
  
    /**
     * Gets and decrypts data from localStorage
     * Returns the decrypted string - you need to JSON.parse() if you stored an object
     */
    static getStorage(key: string): string | null {
      try {
        const ciphertext = localStorage.getItem(key);
        if (!ciphertext) return null;
        
        const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        if (!decrypted) return null;
        
        // Return the raw decrypted string, let caller decide if they need to parse JSON
        return decrypted;
      } catch (error) {
        console.warn(`Error retrieving storage key "${key}":`, error);
        return null;
      }
    }
  
    static removeStorage(key: string) {
      localStorage.removeItem(key)
    }

    static clearStorage() {
      localStorage.clear();
    }

    static getAppDetails() {
      try {
        const details = this.getStorage('App_Details');
        return details ? JSON.parse(details) : null;
      } catch (err) {
        console.log(err)
        return null;
      }
    }

    static getBusinessType() {
      try {
        const details = this.getStorage('Business_Type');
        return details ? JSON.parse(details) : null;
      } catch (err) {
        console.log(err)
        return null;
      }
    }

    static getBusinessCategory() {
      try {
        const details = this.getStorage('Business_Category');
        return details ? JSON.parse(details) : null;
      } catch (err) {
        console.log(err)
        return null;
      }
    }
}
